import React from 'react';
import PropTypes from 'prop-types';
import { ModalContainer, ModalHeaderContainer } from '@containers/layout';
import { Box, Button, Text } from '@components/common';
import { HeadLine } from '@components/Typography';
import DialogBox from '@components/DialogBox';
import CancelConfirm from '@containers/booking/Confirm/CancelConfirm';

function RebookingConfirmModal(props) {
  const { show, dismiss, isRebooking, onSubmit, onFail } = props;

  return (
    <DialogBox show={show} onClickOutside={dismiss}>
      {isRebooking ? (
        <CancelConfirm
          cancelLabel="No"
          submitLabel="Yes"
          title="Book Service"
          description="We’re thrilled you loved your service! We will let your housekeeper know! Would you like to book again?"
          onSubmit={() => {
            dismiss();
            onSubmit();
          }}
          onCancel={() => {
            dismiss();
          }}
        />
      ) : (
        <ModalContainer>
          <ModalHeaderContainer>
            <HeadLine textAlign="center">Rate Service</HeadLine>
          </ModalHeaderContainer>
          <Box display="flex" flexDirection="column">
            <Text fontSize={1} mb={4}>
              Thank you for your feedback.
            </Text>
            <Button flex={1} mb={4} type="button" onClick={onFail}>
              Continue
            </Button>
          </Box>
        </ModalContainer>
      )}
    </DialogBox>
  );
}

RebookingConfirmModal.propTypes = {
  show: PropTypes.bool,
  dismiss: PropTypes.func,
  isRebooking: PropTypes.bool,
  onSubmit: PropTypes.func,
  onFail: PropTypes.func
};

export default RebookingConfirmModal;
